// Auto-generated router configuration
export default [
  {
    "path": "/404",
    "name": "404",
    component: () => import('@/view/404.vue')
  },
  {
    "path": "/advance",
    "name": "Advance",
    component: () => import('@/view/advance.vue')
  },
  {
    "path": "/contract",
    "name": "Contract",
    component: () => import('@/view/contract.vue')
  },
  {
    "path": "/",
    "name": "",
    component: () => import('@/view/index.vue')
  },
  {
    "path": "/news",
    component: () => import('@/view/news/index.vue'),
    "children": [
      {
        "path": "/news/detail",
        "name": "NewsDetail",
        component: () => import('@/view/news/detail.vue')
      },
      {
        "path": "/news",
        "name": "News",
        component: () => import('@/view/news/index.vue')
      }
    ]
  },
  {
    "path": "/receive",
    "name": "Receive",
    component: () => import('@/view/receive.vue')
  },
  {
    "path": "/repertory",
    "name": "Repertory",
    component: () => import('@/view/repertory.vue')
  }
]